export const UserRoles = {
  FREE: 'free',
  SUBSCRIBER: 'subscriber',
  ADMIN: 'admin'
};
